import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// 豪车商品列表接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27700084
export const get_luxury_car_list = createAsyncThunk(
  'RightDiscountSale/luxury_car_list',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/activity/luxury_car_list',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 豪车商品点击购买按钮接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27700333

export const luxury_car_buy = createAsyncThunk(
  'RightDiscountSale/luxury_car_buy',
  async (
    arg: {privilege_id: number; buy_cnt: number; aris_id?: number},
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<{
        status?: number
        err_msg?: string
      }>
    >('/live/activity/luxury_car_buy', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

interface luxury_car_type {
  aris_id?: number
  privilege_id?: number
  picture_url?: string

  car_price: number
  origin_price: number
  car_name: string
  car_effect_days: number

  platform_remain_cnt: number
  platform_limit: number

  user_remain_cnt: number
  user_limit: number
}

interface good_type {
  goods_id?: number // 商品id
  goods_name: string // 商品名称
  goods_pic_url: string // 商品icon
  goods_new_price: number // 现在价格
  goods_origin_price: number // 原价格
  regional_limit: number // 区域购买上限
  regional_remain_cnt: number // 区域剩余个数，小于等于0展示售空
  user_limit: number // 用户购买的上限制
  user_remain_cnt: number // 该商品，用户还能购买几个
  reward_list: {
    reward_id: number
    reward_cnt: number
    reward_display_name: string
    reward_effect_days: number // 有效天数
    reward_pic_url: number // 奖励图片
  }[]
}

interface InitialStateType {
  // 主页面数据
  // 0：开卖中     1：未开始      2：已结束 3:不在活动地区
  status?: number
  count_down?: number
  index?: number
  // item_list?: Array<luxury_car_type>
  item_list?: Array<good_type>
  banner?: string
}

const initialState: InitialStateType = {}

export const RightDiscountSaleSlice = createSlice({
  name: 'RightDiscountSale',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 豪车商品列表接口成功
    builder.addCase(get_luxury_car_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export const useRightDiscountSaleState = () => {
  const data = useSelector((state) => state.RightDiscountSale)
  return data
}

export default RightDiscountSaleSlice.reducer
